import React from 'react';

import { withFirebase } from '../Firebase';

const SignOutButton = ({ firebase }) => (
  <button type='button' className="signOutButton" onClick={firebase.doSignOut}>Uitloggen</button>
);

export default withFirebase(SignOutButton);
